import { useEffect, useState } from "react";
import { CommonBonusDetails } from "../../models/responses/commonBonusDetails";
import {
  retrieveAllCancelledBonusDetails,
  updateUsersFreeSpinCancellation,
} from "../../services/bonus.service";
import localization from "../../../../config/localization";
import InfiniteScroll from "../../../../components/ui/InfiniteScroll";
import CashdropBonus from "../BonusTypes/CashdropBonus";
import { BonusConsts } from "../../models/constants/bonusConsts";
import FreeSpinBonus from "../BonusTypes/FreeSpinBonus";
import DepositBonus from "../BonusTypes/DepositBonus";
import CashbackWinningBoostBonus from "../BonusTypes/CashbackWininngBoost";
import { useAppDispatch } from "../../../../store/hooks";
import { changeLoaderState } from "../../../../reducers/appStateReducer";

export function CancelledBonus() {
  const [data, setData] = useState<CommonBonusDetails[]>([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const PAGE_SIZE = 20;
  const dispatch = useAppDispatch();
  useEffect(() => {
    init();

    const timer = setInterval(async () => {
      await updateUsersFreeSpinCancellation();
      await refreshCancelledBonusList();
    }, 60000);

    return () => clearInterval(timer);
  }, []);

  async function fetchData(pageNo: number, isReset = false) {
    setIsLoading(true);
    const result = await retrieveAllCancelledBonusDetails(pageNo, PAGE_SIZE);

    if (result) {
      setData((prev) => (isReset ? result : [...prev, ...result]));

      if (result.length < PAGE_SIZE) {
        setHasMore(false);
      }
    } else {
      setHasMore(false);
    }

    setIsLoading(false);
  }
  async function refreshCancelledBonusList() {
    const latest = await retrieveAllCancelledBonusDetails(0, PAGE_SIZE);
    if (!latest) return;

    setData((prev) => {
      const prevIds = new Set(prev.map((x) => x.bonuswallettransactionid));
      const newItems = latest.filter(
        (x) => !prevIds.has(x.bonuswallettransactionid),
      );

      return newItems.length ? [...newItems, ...prev] : prev;
    });
  }
  async function loadMore() {
    const nextPage = pageNumber + 1;
    setPageNumber(nextPage);
    await fetchData(nextPage);
  }

  async function init() {
    dispatch(changeLoaderState(true));
    try {
      await updateUsersFreeSpinCancellation();
      await fetchData(0, true);
    } finally {
      dispatch(changeLoaderState(false));
    }
  }

  return (
    <div>
      <InfiniteScroll
        onLoadMore={loadMore}
        hasMore={hasMore}
        isLoading={isLoading}
        endMessage={
          data.length === 0 ? (
            <span>{localization.no_cancelled_bonus}</span>
          ) : null
        }
      >
        <div className="grid grid-cols-1 md:landscape:grid-cols-2 lg:portrait:grid-cols-1 lg:landscape:grid-cols-2 xl:grid-cols-2 gap-4">
          {data.map((item, index) => {
            const bonusCardKey = `${item.bonuswallettransactionid}-${item.bonusid}-${item.bonustype}-${index}`;
            if (item.bonustype === BonusConsts.CashdropBonus) {
              return (
                <div key={bonusCardKey}>
                  <CashdropBonus item={item} />
                </div>
              );
            }
            if (item.bonustype === BonusConsts.FreeSpinBonus) {
              return (
                <div key={bonusCardKey}>
                  <FreeSpinBonus item={item} />
                </div>
              );
            }
            if (item.bonustype === BonusConsts.DepositBonus) {
              return (
                <div key={bonusCardKey}>
                  <DepositBonus item={item} />
                </div>
              );
            }
            if (
              item.bonustype === BonusConsts.CashbackBonus ||
              item.bonustype == BonusConsts.WinningBoostBonus
            ) {
              return (
                <div key={bonusCardKey}>
                  <CashbackWinningBoostBonus item={item} />
                </div>
              );
            }
            return null;
          })}
        </div>
      </InfiniteScroll>
    </div>
  );
}
